var $ = require('js/sw-jquery/sw-jquery');

/**
 * For the top portion of the left nav in model edit- material-selected state
 *
 * Usage:
 *   data-sw-model-edit-material-navigation
 *   Container for the ModelEditMaterialNav
 *
 */
module.exports = function ($fragment) {

    $fragment.swFindWithSelf('[data-sw-model-edit-material-navigation]').each(function () {

        var $el = $(this);
        var modelId = $el.data('swModelEditMaterialNavigation');

        require(['js/lib/models/ModelManager', 'js/lib/views/ModelEditMaterialNavigation'], function (ModelManager, ModelEditMaterialNavigation) {
            ModelManager.amdNewModelEditModel(modelId, function (model) {
                var options = {
                    el: $el,
                    model: model
                };
                new ModelEditMaterialNavigation(options);
            });

        });

    });


};
